import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {AfterViewInit, booleanAttribute, ChangeDetectionStrategy, Component, computed, DestroyRef, input, Input, ViewChild} from "@angular/core";
import {MatSelect, MatSelectModule} from "@angular/material/select";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldControl} from "@angular/material/form-field";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {MatFormFieldControlProxy} from "web-ng2/delt/material/MatFormFieldControlProxy";
import {SakstypeModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {harSammeId} from "felles-ng2/modell/modellHjelpere";
import {Subject} from "rxjs";
import {TranslateModule} from "@ngx-translate/core";
import {MatSelectTipsKomponent} from "web-ng2/delt/komponenter/mat-select-tips/mat-select-tips";
import {NgClass} from "@angular/common";

const debug = initDebugger('VelgSakstypeKomponent');


/** Viser nedtrekksmeny med temaer.
 *
 * <pre>
 * Fungerer med Ng reactive form via ([(skjemakontroll)]="...").
 * Fungerer med <mat-form-field> fra Material.
 *
 * MERK at vi ikke implementerer ControlValueAccessor fra angular.forms, så komponenten vil ikke fungere med
 * [(ngModel)]="..." eller [formControl]="...".
 * </pre>
 */
@Component({
    selector: 'velg-sakstype',
    templateUrl: './velg-sakstype.html',
    styleUrls: ['./velg-sakstype.scss'],
    providers: [{
        provide: MatFormFieldControl,
        useFactory: (komponent: VelgSakstypeKomponent) => new MatFormFieldControlProxy(() => komponent.nedtrekksmeny, komponent.stateChanges),
        deps: [VelgSakstypeKomponent]
    }],
    imports: [
        MatSelectModule,
        ReactiveFormsModule,
        TranslateModule,
        MatSelectTipsKomponent,
        NgClass
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VelgSakstypeKomponent implements AfterViewInit {

    static pausesak = {id: 'ad535345-7b43-4388-88d6-47e990093c72', navn: 'pause'} as SakstypeModell;

    static erPausesak(type: SakstypeModell | null) {
        return type === VelgSakstypeKomponent.pausesak;
    }

    @ViewChild('sakstypevelger') private nedtrekksmeny!: MatSelect;

    sakstyper = input.required<SakstypeModell[]>();
    skjemakontroll = input.required<FormControl<SakstypeModell | null>>();
    placeholder = input('');
    visPausevalg = input(false, {transform: booleanAttribute});

    erValgt = harSammeId;
    pausesak = VelgSakstypeKomponent.pausesak;

    private readonly stateChanges = new Subject<void>();

    constructor(private destroyRef: DestroyRef) {
    }

    ngAfterViewInit(): void {
        this.nedtrekksmeny.stateChanges
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => this.stateChanges.next())
    }

    //hjelpemetoder

}

